module.exports = __webpack_public_path__ + "img/teacher.5bc1aca4.svg";